import api from '@/lib/api';
import { UserRequest, UserResponse, UserUpdateRequest } from '@/types/api';

export const userService = {
  // Listar todos os usuários (filtra por empresa se não for SUPER_ADMIN)
  async getUsers(): Promise<UserResponse[]> {
    const response = await api.get<UserResponse[]>('/users');
    return response.data;
  },

  // Buscar usuário por ID
  async getUserById(id: string): Promise<UserResponse> {
    const response = await api.get<UserResponse>(`/users/${id}`);
    return response.data;
  },

  // Buscar usuário por email
  async getUserByEmail(email: string): Promise<UserResponse> {
    const response = await api.get<UserResponse>(`/users/by-email/${email}`);
    return response.data;
  },

  // Criar novo usuário
  async createUser(userData: UserRequest): Promise<UserResponse> {
    const response = await api.post<UserResponse>('/users', userData);
    return response.data;
  },

  // Atualizar usuário (usa UserRequest completo)
  async updateUser(id: string, userData: UserRequest): Promise<UserResponse> {
    const response = await api.put<UserResponse>(`/users/${id}`, userData);
    return response.data;
  },

  // Deletar usuário
  async deleteUser(id: string): Promise<void> {
    await api.delete(`/users/${id}`);
  },

  // Obter dados do usuário atual
  async getCurrentUser(): Promise<UserResponse> {
    const response = await api.get<UserResponse>('/users/me');
    return response.data;
  },

  // Atualizar perfil do usuário atual
  async updateCurrentUser(userData: UserUpdateRequest): Promise<UserResponse> {
    const response = await api.put<UserResponse>('/users/me', userData);
    return response.data;
  },
};
